import { getParentNodeWidth, layoutToWidth } from '@atlaskit/editor-common/node-width';
import { calcTableWidth } from '@atlaskit/editor-common/styles';
import { getBreakpoint, mapBreakpointToLayoutMaxWidth } from '@atlaskit/editor-common/ui';
import { containsClassName } from '@atlaskit/editor-common/utils';
import { akEditorFullWidthLayoutWidth, akEditorGutterPadding, akEditorTableNumberColumnWidth } from '@atlaskit/editor-shared-styles';
import { getBooleanFF } from '@atlaskit/platform-feature-flags';
// Translates named layouts in number values.
export function getLayoutSize(tableLayout) {
  var containerWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var options = arguments.length > 2 ? arguments[2] : undefined;
  var isFullWidthModeEnabled = options.isFullWidthModeEnabled;
  if (isFullWidthModeEnabled) {
    return containerWidth ? Math.min(containerWidth - akEditorGutterPadding * 2, akEditorFullWidthLayoutWidth) : akEditorFullWidthLayoutWidth;
  }
  var calculatedTableWidth = calcTableWidth(tableLayout, containerWidth, true);
  if (calculatedTableWidth !== 'inherit') {
    return calculatedTableWidth;
  }
  return layoutToWidth[tableLayout] || containerWidth;
}
export function getDefaultLayoutMaxWidth(containerWidth) {
  return mapBreakpointToLayoutMaxWidth(getBreakpoint(containerWidth));
}

// Does the current position point at a cell.
export function pointsAtCell($pos) {
  return $pos.parent.type.spec.tableRole === 'row' && $pos.nodeAfter;
}

// Get the current col width, handles colspan.
export function currentColWidth(view, cellPos, _ref) {
  var colspan = _ref.colspan,
    colwidth = _ref.colwidth;
  var width = colwidth && colwidth[colwidth.length - 1];
  if (width) {
    return width;
  }
  // Not fixed, read current width from DOM
  var domWidth = view.domAtPos(cellPos + 1).node.offsetWidth;
  var parts = colspan || 0;
  if (colwidth) {
    for (var i = 0; i < (colspan || 0); i++) {
      if (colwidth[i]) {
        domWidth -= colwidth[i];
        parts--;
      }
    }
  }
  return domWidth / parts;
}

// Attempts to find a parent TD/TH depending on target element.
export function domCellAround(target) {
  while (target && target.nodeName !== 'TD' && target.nodeName !== 'TH') {
    target = containsClassName(target, 'ProseMirror') ? null : target.parentNode;
  }
  return target;
}
export var getTableMaxWidth = function getTableMaxWidth(_ref2) {
  var table = _ref2.table,
    tableStart = _ref2.tableStart,
    state = _ref2.state,
    layout = _ref2.layout,
    getEditorContainerWidth = _ref2.getEditorContainerWidth;
  var containerWidth = getEditorContainerWidth();
  var parentWidth = getParentNodeWidth(tableStart, state, containerWidth);
  var maxWidth = getBooleanFF('platform.editor.custom-table-width') ? parentWidth || table.attrs.width || getLayoutSize(layout, containerWidth.width, {}) : parentWidth || getLayoutSize(layout, containerWidth.width, {});
  if (table.attrs.isNumberColumnEnabled) {
    maxWidth -= akEditorTableNumberColumnWidth;
  }
  return maxWidth;
};